import { render, staticRenderFns } from "./FirstReplyWorkspace.vue?vue&type=template&id=282cd6f4&scoped=true&"
import script from "./FirstReplyWorkspace.vue?vue&type=script&lang=js&"
export * from "./FirstReplyWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./FirstReplyWorkspace.vue?vue&type=style&index=0&id=282cd6f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282cd6f4",
  null
  
)

export default component.exports